<template>
  <div style="width: 100%;height: 100%;">
    <el-scrollbar
      class="card-nav"
      ref="cardNav"
      v-show="!noData"
      :wrap-class="wrapClass"
    >
      <!--快捷入口-->
      <div class="shortcut-list">
        <div class="nav-title">{{$t('components.widgetHomepage.nav.shortcut_title')}}</div>
        <div class="content cf">
          <div
            class="content-item fl"
            v-for="item in shortcutNav"
            :key="item.id"
            @click="navCardClick(item)"
          >
            <img
              :src="item.iconInfo.path"
              width="48px"
              height="48px"
            />
            <div
              class="sub-nav-title"
              :title="item.name"
            >{{item.name}}</div>
            <div
              class="remove h-icon-close"
              @click.stop="removeShortcutNav(item.menuId)"
            ></div>
          </div>
          <div
            class="content-empty fl"
            @click="addShortcutNav"
          >
            <!--<span class="add-icon-plus"></span>-->
          </div>
        </div>
      </div>
      <!-- 卡片菜单-->
      <div class="menu-list cf">
        <div
          class="menu-list-item fl"
          v-for="(item, index) in totalNav"
          v-show="item.isShow === 0"
          :key="index"
        >
          <div class="menu-list-item-title-cnt">
            <img
              class="menu-list-item-img"
              :src="item.iconInfo.path"
              width="48px"
              height="48px"
            />
            <div
              class="menu-list-item-title"
              :title="item.name"
            >{{item.name}}</div>
          </div>
          <div class="menu-list-second">
            <span
              class="menu-list-second-title"
              v-for="child in item.children"
              v-show="child.isShow===0"
              :key="child.id"
              @click="navCardClick(child)"
            >{{child.name}}</span>
          </div>
        </div>
      </div>
      <!--添加快捷入口弹窗-->
      <el-dialog
        :visible.sync="shortcutDialog"
        size="small"
        :area="[760, 561]"
        customClass="no-scroll no-padding"
        :close-on-click-modal="false"
        append-to-body
      >
        <div
          slot="title"
          class="shortcut-dialog-title"
        >
          <span class="title-strong">{{$t('components.widgetHomepage.nav.shortcut_title')}}</span>
          <span class="title-light">(</span>
          <span class="title-light">{{navCheckList.length}}</span>
          <span class="title-light">/10</span>
          <span class="title-light">{{$t('components.widgetHomepage.nav.add_shortcut_tips')}}</span>
          <span class="title-light">)</span>
        </div>
        <div class="shortcut-nav">
          <draggable
            class="shortcut-nav-list cf"
            v-model="tempShortcutNav"
          >
            <div
              class="shortcut-nav-item fl"
              v-for="item in tempShortcutNav"
              v-show="item.isShow===0"
              :key="item.id"
            >
              <span>{{item.name}}</span>
              <span
                class="h-icon-close shortcut-nav-item-remove"
                @click="deleteTempShortcut(item.menuId)"
              ></span>
            </div>
          </draggable>
          <div class="shortcut-total-nav-list">
            <el-checkbox-group
              v-model="navCheckList"
              @change="navCheckChange"
            >
              <div
                class="shortcut-total-nav-item"
                v-for="item in totalNav"
                v-show="item.isShow===0"
                :key="item.id"
              >
                <div class="total-nav-item-title">{{item.name}}</div>
                <el-checkbox
                  v-for="child in item.children"
                  v-show="child.isShow===0"
                  :label="child.menuId"
                  class="nav-checkbox"
                  :key="child.id"
                  :disabled="checkboxDisabled && navCheckList.indexOf(child.menuId) === -1"
                >{{child.name}}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer">
          <el-button
            type="primary"
            @click="saveShortcutNav"
          >{{$t('components.widgetHomepage.nav.confirm')}}</el-button>
          <el-button @click="cannelShortcutNav">{{$t('components.widgetHomepage.nav.cancel')}}</el-button>
        </span>
      </el-dialog>
    </el-scrollbar>
    <no-data v-show="noData"></no-data>
  </div>

</template>

<script>
/*
   *  有卡片类型的导航
   * */
// 拖动事件
import noData from './no-data'
import draggable from 'vuedraggable'
import api from 'api/api'
import { mapActions } from 'vuex'
import defaultPic from '../../../assets/images/noicon.png'
import { Loading } from 'hui'
export default {
  name: 'card-nav',
  props: {
    refreshPeriod: {
      // 部件刷新周期
      type: Number,
      default: 0
    }
  },
  created () {
    this.init()
    this.loopRefreshWidget()
  },
  data () {
    return {
      noData: false,
      shortcutNav: [], // 快捷菜单
      tempShortcutNav: [], // 临时快捷菜单数据
      totalNav: {}, // 所有菜单
      shortcutDialog: false, // 快捷导航flag
      navCheckList: [], // 快捷导航选中集合
      currentChenklist: [], // 当前快捷导航选中集合
      checkboxDisabled: false, // 复选框禁用flag
      wrapClass: 'el-nav-scrollbar__wrap'
    }
  },
  watch: {
    shortcutDialog (val) {
      if (val) {
        this.wrapClass = 'el-nav-scrollbar__wrap hidden'
      } else {
        this.wrapClass = 'el-nav-scrollbar__wrap'
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this._getMenu()
    },
    // 获取首页菜单
    _getMenu () {
      let loadingInstance = Loading.service({ fullscreen: true })
      api.homepage
        .menuList()
        .then(data => {
          loadingInstance.close()
          this.noData = false
          this.totalNav = data.data.filter(item => {
            if (item.index === true) {
              return false
            } else if (item.quick === true) {
              this.shortcutNav = item.children || []
              this.tempShortcutNav = item.children || []
              return false
            } else if (!item.children || item.children.length === 0) {
              return false
            }
            return true
          })
          this.totalNav.forEach(item => {
            item.iconInfo.path = item.iconInfo.fileId
              ? item.iconInfo.path
              : defaultPic
            item._path = `/${item.menuId}`
            if (item.children && item.children.length !== 0) {
              item.children.forEach(child => {
                child._path = `/${child.parentId}/${child.menuId}`
              })
            }
          })
          this.shortcutNav.forEach(child => {
            child._path = `/${child.parentId}/${child.menuId}`
          })
        })
        .catch(() => {
          loadingInstance.close()
          this.noData = true
        })
    },
    // 轮巡请求
    loopRefreshWidget () {
      if (this.refreshPeriod !== 0) {
        setInterval(() => {
          this._getMenu()
        }, this.refreshPeriod * 1000)
      }
    },
    /**
     * 编辑快捷导航相关事件
     */
    // 添加快捷导航事件
    addShortcutNav () {
      this.tempShortcutNav = JSON.parse(JSON.stringify(this.shortcutNav))
      this.navCheckList = []
      this.shortcutNav.forEach(item => {
        this.navCheckList.push(item.menuId)
      })
      this.currentChenklist = JSON.parse(JSON.stringify(this.navCheckList))
      this.shortcutDialog = true
      this.checkboxDisabled = this.navCheckList.length >= 10
    },
    // 保存快捷导航
    saveShortcutNav () {
      let menuIds = []
      this.tempShortcutNav.forEach(item => {
        menuIds.push(item.menuId)
      })
      api.homepage
        .add({ menuIds: menuIds.join(',') })
        .then(data => {
          this.shortcutNav = JSON.parse(JSON.stringify(this.tempShortcutNav))
          this.$message.success(
            this.$t('components.widgetHomepage.nav.edit_menu_suc')
          )
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
      this.shortcutDialog = false
    },
    // 取消快捷导航
    cannelShortcutNav () {
      this.shortcutDialog = false
    },
    // 复选框变化事件
    navCheckChange (checks) {
      if (checks.length === this.currentChenklist.length) {
        return
      }
      // 最多不能超过10个
      this.checkboxDisabled = checks.length >= 10
      // 判断是增加还是减少
      let checkFlag = checks.length > this.currentChenklist.length
      let changeItem = this.$lodash.xor(checks, this.currentChenklist)
      if (checkFlag) {
        this.totalNav.forEach(item => {
          item.children.forEach(child => {
            if (child.menuId.toString() === changeItem[0]) {
              this.tempShortcutNav.push(child)
            }
          })
        })
      } else {
        this.tempShortcutNav = this.tempShortcutNav.filter(item => {
          return item.menuId !== changeItem[0]
        })
      }
      this.currentChenklist = JSON.parse(JSON.stringify(checks))
    },
    // 删除快捷菜单
    removeShortcutNav (menuId) {
      api.homepage
        .delete({ shortcutIds: menuId })
        .then(() => {
          this.$message.success(
            this.$t('components.widgetHomepage.nav.edit_menu_suc')
          )
          this.shortcutNav = this.shortcutNav.filter(item => {
            return menuId !== item.menuId
          })
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 弹框中去除选中的快捷菜单
    deleteTempShortcut (id) {
      this.tempShortcutNav = this.tempShortcutNav.filter(item => {
        return item.menuId !== id
      })
      this.navCheckList = this.navCheckList.filter(item => {
        return item !== id
      })
      this.currentChenklist = this.currentChenklist.filter(item => {
        return item !== id
      })
      this.checkboxDisabled = this.navCheckList.length >= 10
    },
    // 菜单点击
    navCardClick (menu) {
      if (menu.openType === 2) {
        window.open(menu.url)
      } else {
        this.openMenu({
          value: menu.menuId,
          key: 'menuId'
        })
      }
    },
    // vuex
    ...mapActions(['openMenu'])
  },
  components: {
    draggable,
    noData
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";

.card-nav {
  position: relative;
  padding: 16px 0 16px 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: @bg-1;
  max-width: 955px;
  margin: 0 auto;
  .shortcut-list {
    box-sizing: border-box;
    .nav-title {
      height: 16px;
      line-height: 16px;
      font-size: @font-size-b;
      color: @font-color-2;
    }
    .content {
      padding-top: 14px;
      .content-empty {
        height: 100px;
        width: 104px;
        text-align: center;
        cursor: pointer;
        background: url("../../../assets/images/card_menu_add_small.png")
          no-repeat center;
        margin-bottom: 32px;
      }
      .content-item {
        position: relative;
        margin-right: 16px;
        box-sizing: border-box;
        background-color: #fff;
        height: 100px;
        width: 104px;
        text-align: center;
        padding-top: 10px;
        cursor: pointer;
        border-radius: 2px;
        box-shadow: 0 1px 1px #ccc;
        margin-bottom: 32px;
        .remove {
          position: absolute;
          right: 4px;
          top: 4px;
          display: none;
        }
        &:hover {
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
          .remove {
            display: block;
          }
        }
        /*.image{*/
        /*display: block;*/
        /*width: 48px;*/
        /*height: 48px;*/
        /*margin-left: 28px;*/
        /*margin-bottom: 12px;*/
        /*}*/
        .sub-nav-title {
          display: inline-block;
          width: 100%;
          font-size: @font-size;
          color: @font-color;
          height: 14px;
          line-height: 14px;
          .text-over();
        }
      }
    }
  }
  .menu-list {
    .menu-list-item {
      background-color: #fff;
      box-sizing: border-box;
      width: 296px;
      height: 168px;
      margin: 0 16px 16px 0;
      padding: 16px 0 0 28px;
      box-shadow: 0 1px 1px #ccc;
      &:hover {
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      }
      .menu-list-item-title-cnt {
        margin-bottom: 24px;
        .menu-list-item-img {
          vertical-align: middle;
        }
        .menu-list-item-title {
          display: inline-block;
          width: 215px;
          box-sizing: border-box;
          padding: 0 16px;
          vertical-align: middle;
          font-size: @font-size-b;
          color: @font-color-7;
          .text-over();
        }
      }
      .menu-list-second {
        font-size: 0;
        height: 78px;
        overflow: auto;
        .menu-list-second-title {
          cursor: pointer;
          display: inline-block;
          margin: 0 20px 12px 0;
          height: 14px;
          line-height: 14px;
          font-size: @font-size;
          color: @font-color;
        }
      }
    }
  }
}
</style>
<style lang="less">
@import "~assets/styles/var.less";
@import "~assets/styles/mixin.less";
.shortcut-dialog-title {
  width: 700px;
  float: left;
  height: 40px;
  padding-left: 16px;
  .title-strong {
    font-size: @font-size-title;
    font-weight: bold;
    color: @font-color-5;
  }
  .title-light {
    font-size: @font-size;
    color: @font-color-l;
  }
}
/*弹框样式*/
.shortcut-nav {
  box-sizing: border-box;
  padding: 25px 24px 0 24px;
  .shortcut-nav-list {
    padding: 0 0 8px 0;
    .shortcut-nav-item {
      height: 30px;
      margin: 0 8px 8px 0;
      line-height: 30px;
      padding: 0 40px 0 15px;
      font-size: @font-size-b;
      color: @font-color-6;
      background-color: @bg;
      border: 1px solid @border-color3;
      border-radius: 2px;
      cursor: move;
      position: relative;
      .shortcut-nav-item-remove {
        cursor: pointer;
        position: absolute;
        font-size: 8px;
        top: 9px;
        right: 11px;
      }
    }
  }
  .shortcut-total-nav-list {
    .shortcut-total-nav-item {
      .total-nav-item-title {
        font-size: @font-size;
        color: @font-color-l;
        line-height: 20px;
        margin: 0 0 8px 0;
      }
      .nav-checkbox {
        margin: 0 36px 15px 0;
        color: @font-color-5;
      }
    }
  }
}
</style>
